import { Session } from 'next-auth'

import { Role } from '@elendi/util-shared-constants'

export const getRole = (session: Session | null) => (session?.['role'] ?? Role.LOGGED_OUT) as Role

export const getName = (session: Session | null) =>
  (session?.['fullName'] ?? session?.user?.name ?? session?.user?.email) as string
